import { combineReducers } from 'redux';
import { productsListReducer } from './reducers/products-list-reducer';
import { licensesListReducer } from './reducers/licenses-list-reducer';
import { licenseRolesReducer } from './reducers/license-roles-reducer';
import { licenseUsersReducer } from './reducers/license-users-reducer';
import { licenseSelectedReducer } from './reducers/license-selected-reducer';

export default combineReducers({
  productsListReducer,
  licensesListReducer,
  licenseRolesReducer,
  licenseUsersReducer,
  licenseSelectedReducer,
});
